<template>
  <div>
    <DialogBase
      v-model="inputValue"
      :title="
        $t('common.common_transfer-account') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
    >
      <div class="px-5 pb-5">
        <InputFormNew
          v-model="inputData"
          :detail="items"
          :titleCols="inputFormStyle.titleCols"
          :contentsCols="inputFormStyle.contentsCols"
          :master-data="transferAccount"
        >
          <template #defaultCurrency="{ item }">
            <SelectCurrency v-model="item.defaultCurrency" />
          </template>
        </InputFormNew>
        <NormalButton
          :text="buttonName"
          textSize="16px"
          height="50px"
          width="100%"
          class="pt-5"
          @click.native="complete()"
        />
      </div>
    </DialogBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import { InputFormNew, NormalButton } from '@/components/items'
import _cloneDeep from 'lodash/cloneDeep'
import { SelectCurrency } from '@/components/items/Selectboxes'
export default {
  components: {
    DialogBase,
    InputFormNew,
    NormalButton,
    SelectCurrency
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    buttonName: { default: 'common.input_save' },
    transferAccountData: { type: Object, require: false, default: () => ({}) },
    editMode: { type: Boolean, require: false, default: false }
  },
  data: () => ({
    inputFormStyle: {
      titleCols: 3,
      contentsCols: 9
    },
    inputData: {},
    transferAccount: [],
    items: [
      {
        name: 'name',
        text: 'common.common_transfer-account',
        required: true
      },
      {
        name: 'defaultCurrency',
        text: 'user.user_default-currency',
        cols: Math.ceil(3)
      },
      {
        name: 'sortNumber',
        text: 'common.input_sort-number',
        required: true,
        placeholder: '',
        cols: Math.ceil(5),
        component: 'SelectSortNumber'
      }
    ]
  }),

  created() {
    this.init()
  },

  methods: {
    ...mapActions('TransferAccount', [
      'registerTransferAccount',
      'editTransferAccount'
    ]),
    ...mapGetters('TransferAccount', [
      'getMaxSortNumber',
      'getTransferAccountListFromState'
    ]),
    // ...mapGetters('Common', ['getCurrencyJpFromState']),

    init() {
      const formatData = _cloneDeep(this.transferAccountData)
      formatData.sortNumber = this.editMode
        ? this.transferAccountData.sortNumber
        : this.getMaxSortNumber() + 1
      formatData.defaultCurrency = {
        value: formatData.defaultCurrencyId
          ? formatData.defaultCurrencyId
          : null
      }
      this.inputData = formatData
      this.transferAccount = this.getTransferAccountListFromState()
    },
    async complete() {
      if (this.editMode) {
        this.inputData.id = this.inputData.TransferAccountId
      }
      const success = this.editMode
        ? await this.editTransferAccount(this.inputData)
        : await this.registerTransferAccount(this.inputData)

      if (success) {
        this.$emit('success')
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
</style>
